import * as XLSX from "xlsx";

const parseTranslationsFromExcel = async (file: File): Promise<Record<string, string>> => {
	const buffer = await file.arrayBuffer();

	const workbook = XLSX.read(buffer, { type: "array" });
	const sheet = workbook.Sheets[workbook.SheetNames[0]];

	const rows = XLSX.utils.sheet_to_json<{ key: string; ru: string }>(sheet);

	const result: Record<string, string> = {};

	rows.forEach((row) => {
		if (!row.key) return;

		// Заменяем все переносы Excel (Alt+Enter) на \n
		const value = String(row.ru ?? "")
			.replace(/\r?\n/g, "\n ")
			.trim();
		result[row.key.trim()] = value;
	});

	return result;
};

export default parseTranslationsFromExcel;
